import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { MapContainer, TileLayer, Marker, Polyline, useMap, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './RealTimeTrackingModal.scss';
import { getRealTimeTracking } from '../MaestroDeServiciosIntegracion';
import busMarker from '../../../../assets/icons/camion.png';
// Fix para los iconos de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


// Icono personalizado para el vehículo en movimiento

const markerUnidad = new L.Icon({
    iconUrl: busMarker,
    iconSize: [50, 25],
    iconAnchor: [16, 25],
    popupAnchor: [0, -32],
});

const RealTimeTrackingModal = ({ visible, onHide, operadorId, unidadId, fecha, operador }) => {
    const [loading, setLoading] = useState(false);
    const [trackingData, setTrackingData] = useState(null);
    const [currentPosition, setCurrentPosition] = useState(null);
    const [routePath, setRoutePath] = useState([]);
    const [mapCenter, setMapCenter] = useState([20.6597, -103.3496]); // Guadalajara por defecto
    const intervalRef = useRef(null);
    const [hoverInfo, setHoverInfo] = useState(null); // { latlng: LatLng, hora: string }

    // const [isTracking, setIsTracking] = useState(false);
    // const [lastUpdate, setLastUpdate] = useState(null);
    // const [totalDistance, setTotalDistance] = useState(0);

    // Función para obtener datos de seguimiento
    const fetchTrackingData = async () => {
        if (!operadorId && !unidadId && !operador) return;

        try {
            const params = {
                id_unidad: unidadId,
                fecha: fecha
            };
            // lat: 20.7271883,
            //     lng: -103.4823349,
            //         velocidad: 0,
            //             Hora: '06:35:47'
            await getRealTimeTracking((data) => {
                setRoutePath(data.trazo);
                setTrackingData(data);
                setLoading(false);
            }, params);
        } catch (error) {
            console.error('Error al obtener datos de seguimiento:', error);
            setLoading(false);
        }
    };

    // Iniciar seguimiento cuando el modal se abre
    useEffect(() => {
        if (visible) {
            setLoading(true);
            // setIsTracking(true);
            fetchTrackingData();

            // Configurar intervalo de actualización cada 5 segundos
            // intervalRef.current = setInterval(() => {
            //     fetchTrackingData();
            // }, 5000);
        } else {
            // Limpiar cuando el modal se cierra
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            // setIsTracking(false);
            setTrackingData(null);
            setCurrentPosition(null);
            setRoutePath([]);
            // setLastUpdate(null);
            // setTotalDistance(0);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [visible, operadorId, unidadId, fecha]);

    // Función para pausar/reanudar seguimiento
    // const toggleTracking = () => {
    //     if (isTracking) {
    //         clearInterval(intervalRef.current);
    //         intervalRef.current = null;
    //         setIsTracking(false);
    //     } else {
    //         fetchTrackingData();
    //         intervalRef.current = setInterval(() => {
    //             fetchTrackingData();
    //         }, 5000);
    //         setIsTracking(true);
    //     }
    // };
    function getClosestPoint(mouseLatLng, points) {
        let minDist = Infinity;
        let closestPoint = null;
        for (let point of points) {
            const dist = mouseLatLng.distanceTo(L.latLng(point.lat, point.lng));
            if (dist < minDist) {
                minDist = dist;
                closestPoint = point;
            }
        }
        return closestPoint;
    }
    const handleClick = (e) => {
        if (!routePath) return;
        const mouseLatLng = e.latlng;
        const closest = getClosestPoint(mouseLatLng, routePath);
        if (closest) {
            setHoverInfo({
                latlng: L.latLng(closest.lat, closest.lng),
                hora: closest.hora || "Hora no disponible",
            });
        }
    };
    const handleClose = () => {
        setHoverInfo(null);
    };


    const header = (
        <div className="tracking-modal-header">
            <div className="header-icon">
                <i className="pi pi-map-marker"></i>
            </div>
            <div className="header-text">
                <h2>Seguimiento</h2>
                <p>Unidad: {unidadId || 'N/A'} - Operador: {operador || 'N/A'}</p>
            </div>
            {/* {lastUpdate && (
                <Chip
                    label={`Última actualización: ${lastUpdate.toLocaleTimeString()}`}
                    icon="pi pi-clock"
                    className="update-chip"
                />
            )} */}
        </div>
    );

    const footer = (
        <div className="tracking-modal-footer">
            <div className="footer-stats">
                {/* {trackingData?.trazo && (
                    <Chip
                        label={`Velocidad: ${trackingData.trazo[trackingData.trazo.length - 1].velocidad} km/h`}
                        icon="pi pi-gauge"
                        className="stat-chip"
                    />
                )} */}
                <Chip
                    label={`Puntos: ${routePath.length}`}
                    icon="pi pi-map"
                    className="stat-chip"
                />
            </div>
            <div className="footer-actions">
                {/* <Button
                    label={isTracking ? "Pausar" : "Reanudar"}
                    icon={isTracking ? "pi pi-pause" : "pi pi-play"}
                    onClick={toggleTracking}
                    className="p-button-warning"
                /> */}
                <Button
                    label="Cerrar"
                    icon="pi pi-times"
                    onClick={onHide}
                    className="p-button-secondary"
                />
            </div>
        </div>
    );

    return (
        <Dialog
            header={header}
            visible={visible}
            style={{ width: '90vw', height: '85vh' }}
            onHide={onHide}
            footer={footer}
            maximizable
            className="real-time-tracking-modal"
        >
            <div className="tracking-content">
                {loading ? (
                    <div className="loading-container">
                        <ProgressSpinner />
                        <p>Cargando datos de seguimiento...</p>
                    </div>
                ) :
                    <div className="map-container-tracking">
                        <MapContainer
                            center={mapCenter}
                            zoom={15}
                            style={{ height: '100%', width: '100%' }}
                        >
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; CARTO'
                                url={'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_272a_1_35c523a1879227e1480394f9'}
                                errorTileUrl="https://upload.wikimedia.org/wikipedia/commons/e/e0/Blank.png"
                            />
                            {/* <MapCenterUpdater center={currentPosition} /> */}

                            {/* Marcador de posición actual */}
                            {/* {currentPosition && (
                                <Marker position={currentPosition} icon={markerUnidad} />
                            )} */}

                            {/* Polilínea del recorrido si das click en la polyline se mostrara el tiempo que se llama routePath.hora */}

                            {routePath.length > 1 && (
                                <Polyline
                                    positions={routePath}
                                    color="#0078d4"
                                    weight={4}
                                    opacity={0.7}
                                    eventHandlers={{
                                        click: handleClick,
                                    }}
                                />
                            )}
                            {hoverInfo && (
                                <Popup
                                    position={hoverInfo.latlng}
                                    autoPan={false}
                                    closeButton={true}
                                    onClose={handleClose}
                                >
                                    <div style={{ fontWeight: "bold" }}>{hoverInfo.hora}</div>
                                </Popup>
                            )}
                        </MapContainer>

                        {/* Indicador de actualización */}
                        {/* {isTracking && (
                            <div className="tracking-indicator">
                                <i className="pi pi-sync pi-spin"></i>
                                <span>Actualizando cada 5 segundos</span>
                            </div>
                        )} */}
                    </div>
                }
            </div>
        </Dialog>
    );
};

export default RealTimeTrackingModal;
